module.exports = __webpack_public_path__ + "media/St 4-refrigerator-correct.ea665456.wav";